import api from './client'
import type { PhotoCheckKind } from '../photo-slots'

/**
 * Проверка фото в поле карточки тренда после загрузки (18.10): есть ли лицо, виден ли человек целиком, нет ли людей.
 * Что проверять, решает тип поля (photo-slots), включает проверку админ на конкретное поле. Ответ — подсказка внутри
 * плитки; measured=false — сервер не смог (файл чужой, модели нет, долго): плитка молчит, запуск не держится.
 */
export interface PhotoCheckResult {
	measured: boolean
	ok?: boolean
	code?: string
	/** Короткий текст в плитку: «лицо найдено», «ноги не в кадре». */
	text?: string
	/** Подсказка целиком (title): «Нужен человек с головы до ног…». */
	note?: string
}

export function checkPhoto(url: string, check: PhotoCheckKind): Promise<PhotoCheckResult> {
	return api.request<PhotoCheckResult>('/api/v1/files/photo-check', { method: 'POST', body: { url, check } })
}
